import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const RECENT_PURCHASES = [{
  name: 'Martín G.',
  city: 'Buenos Aires'
}, {
  name: 'Sofía L.',
  city: 'Córdoba'
}, {
  name: 'Lucas M.',
  city: 'Rosario'
}, {
  name: 'Valentina R.',
  city: 'Mendoza'
}, {
  name: 'Juan P.',
  city: 'La Plata'
}, {
  name: 'Camila S.',
  city: 'Mar del Plata'
}, {
  name: 'Nicolás F.',
  city: 'Tucumán'
}, {
  name: 'Agustina B.',
  city: 'Neuquén'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(RECENT_PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle through purchases
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomIdx = Math.floor(Math.random() * RECENT_PURCHASES.length);
        setCurrentPurchase(RECENT_PURCHASES[randomIdx]);
        setIsVisible(true);
      }, 2000); // Wait 2s before showing next one
    }, 15000); // Show every 15 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-6 z-50 animate-in slide-in-from-bottom-5 fade-in duration-700 max-w-xs w-full" data-id="element-6">
      <div className="bg-white rounded-2xl shadow-lg p-4 flex items-start gap-4 relative border-l-4" style={{
      borderColor: 'var(--color-blush)'
    }} data-id="element-7">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 opacity-40 hover:opacity-100 transition-opacity" style={{
        color: 'var(--color-text)'
      }} data-id="element-8">
          <X size={14} data-id="element-9" />
        </button>

        <div className="p-2 rounded-full flex-shrink-0 mt-1" style={{
        backgroundColor: 'var(--color-rose-soft)'
      }} data-id="element-10">
          <CheckCircle2 className="w-5 h-5" style={{
          color: '#8BA888'
        }} data-id="element-11" />
        </div>

        <div data-id="element-12">
          <p className="text-sm font-bold font-heading" style={{
          color: 'var(--color-text)'
        }} data-id="element-13">
            ¡Nueva compra verificada!
          </p>
          <p className="text-xs mt-1" style={{
          color: 'var(--color-text-light)'
        }} data-id="element-14">
            <span className="font-semibold" style={{
            color: 'var(--color-text)'
          }} data-id="element-15">
              {currentPurchase.name}
            </span>{' '}
            de {currentPurchase.city}
          </p>
          <p className="text-xs mt-1" style={{
          color: 'var(--color-text-light)'
        }} data-id="element-16">
            Compró{' '}
            <span className="font-medium italic" style={{
            color: 'var(--color-cafe)'
          }} data-id="element-17">
              Sistema SALÍ DEL 99%
            </span>
          </p>
          <p className="text-[10px] mt-2 opacity-60" style={{
          color: 'var(--color-text-light)'
        }} data-id="element-18">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}